<template>
  <div
    class="uc-embed"
    uc-styling="true"
    :uc-embedding-type="embedType"
    :uc-show-toggle="serviceToggle"
  />
</template>

<script lang="ts" setup>
interface Props {
  embedType?: string;
  serviceToggle?: boolean;
}

withDefaults(defineProps<Props>(), {
  embedType: 'category',
  serviceToggle: false,
});

onMounted(() => {
  if (window.UC_UI?.restartEmbeddings) {
    window.UC_UI.restartEmbeddings();
  }
});
</script>
